<template>

    <div>

        <div class="row">

            <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 mb-3" v-for="(image, index) in images" :key="index">

                <a v-bind:href="image" target="_blank">
                    <img v-bind:src="image" class="rounded img-fluid" alt="">
                </a>

                <table style="width: 100%; font-size: .875rem;">
                    <tr>
                        <td class="text-truncate" style="max-width:1px;">{{ getNameFromUrl(image) }}</td>
                        <td style="width: 40px;"><a href="javascript:void(0)" @click="clear(index)" class="text-danger">{{ t.__('Usuń') }}</a></td>
                    </tr>
                </table>

                <input type="hidden" :name="inputName + '[' + index + ']'" v-model="images[index]">

            </div>

        </div>

        <div>
            <a href="javascript:void(0)" class="btn btn-primary" @click="showFileManager()">{{ t.__('Dodaj') }}</a>
        </div>

    </div>

</template>

<script>
    export default {
        props: ['eventHub', 'inputName', 'currentValue', 'mimeTypes'],
        data() {
            return {
                images: [],
                newImage: null
            }
        },
        methods: {
            showFileManager() {
                this.eventHub.$emit('show-file-manager', this._uid, 'file', this.mimeTypes)
            },
            clear(index) {
                this.images.splice(index, 1);
            },
            getNameFromUrl(url) {
                return url.substring(url.lastIndexOf('/')+1);
            }
        },
        mounted() {
            if (CONFIG.oldInput.hasOwnProperty(this.inputName))  {
                this.images = CONFIG.oldInput[this.inputName];
            } else if (this.currentValue != null) {
                this.images = this.currentValue;
            }

            this.eventHub.$on('file-manager-selected-' + this._uid, (file) => {
                this.images.push(file.webPath);
                this.eventHub.$emit('hide-file-manager')
            });
        }
    };
</script>
